<script lang="ts">
	import { ActionsContainer, AdvancedCard, IconButton, LabelList } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';

	import type { MathParameter } from 'src/types/Scenes/MathConditionUI';
	import { getMathParamPreview } from 'src/components/Scenes/helpers/math_based/math_param_utils';
	import ParamItemHolder from './ParamItemHolder.svelte';

	export let index = 0; // index of the math parameter
	export let mathParameter: MathParameter;
	export let onClickEdit: (name: string) => void;
	export let onClickDelete: (name: string) => void;

	$: preview = getMathParamPreview(mathParameter);
</script>

<ParamItemHolder {index} name={mathParameter.name}>
	<AdvancedCard avatar={preview.avatar} title={preview.title} isCondensed>
		<LabelList labelList={preview.labelList} slot="main" size="s" />
		<ActionsContainer orientation="horizontal" type="simple" slot="right">
			<IconButton
				aria-label={$format('button_edit_parameter', { default: 'Edit parameter' })}
				icon="fas fa-pen"
				slot="first"
				on:click={() => {
					onClickEdit(mathParameter.name);
				}}
			/>
			<IconButton
				aria-label={$format('button_delete_parameter', { default: 'Delete parameter' })}
				icon="fas fa-trash"
				variant="danger"
				slot="second"
				on:click={() => {
					onClickDelete(mathParameter.name);
				}}
			/>
		</ActionsContainer>
	</AdvancedCard>
</ParamItemHolder>
